module.exports = ".delete-comprobante {\n  color: #fa5c7c; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/modal-comprobantes-liquidacion/modal-comprobantes-liquidacion.component.scss
// module id = ./src/app/components/tools/modal-comprobantes-liquidacion/modal-comprobantes-liquidacion.component.scss
// module chunks = main